import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { CampanhaService } from '../api/services/campanha.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-card-campanha-dash-admin',
  imports: [
    CommonModule,
    MoneyPipe,
    TagModule,
    Menu,
    ButtonModule,
    Dialog
  ],
  providers: [
    CampanhaService
  ],
  templateUrl: './card-campanha-dash-admin.component.html',
  styleUrl: './card-campanha-dash-admin.component.scss'
})
export class CardCampanhaDashAdminComponent implements OnInit {
  @Input() dados!: any[];
  @Input() codigo!: string;
  @Input() titulo!: string;
  @Input() Sector!: string;
  @Input() Objectivo!: number;
  @Input() Arrecadado!: number;
  @Input() DataCriacao!: string;
  @Input() estado!: string;
  openedMenu: Menu | null = null;
  @Input() actions: ((rowData: any) => MenuItem[]) | MenuItem[] = [];
  @Output() rowClick = new EventEmitter<any>();
  @Input() campanha!: any;
    @Input() activeMenu!: Menu | null;
  @Output() menuOpened = new EventEmitter<Menu>();
  @Output() menuClosed = new EventEmitter<void>();

  displayModal: boolean = false;
  loading: boolean = false;
  prorrogarSelecionada: any;
  private readonly confirmationService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);
    private readonly campanhaService = inject(CampanhaService);


  constructor() { }

  ngOnInit(): void {
    this.temProrrogarAtiva(this.campanha);
  }

  getSeverity(state: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | null | undefined {
    switch (state) {
      case 'Rascunho':
        return 'secondary';
      case 'Em curso':
        return 'info';
      case 'Pendente':
        return 'secondary';
      case 'Encerrado':
        return 'success';
      case 'Suspensa':
        return 'warn';
      case 'Recusado':
        return 'danger';
      case 'Concluída':
        return 'success';
      case 'Sucesso':
        return 'contrast';
      default:
        return 'info';
    }
  }

  getMenuActions(rowData: any): MenuItem[] {
    if (typeof this.actions === 'function') {
      return this.actions(rowData);
    }

    return this.actions.map((action) => ({
      ...action,
      data: rowData,
    }));
  }

  updateMenuActions() {
    if (!this.dados) return;

    this.dados = this.dados.map(rowData => ({
      ...rowData,
      menuActions: this.getMenuActions(rowData),
    }));
  }

  openMenu(event: MouseEvent, menu: Menu) {
    event.preventDefault();
    event.stopPropagation();

    this.menuOpened.emit(menu);
    menu.show(event);
  }

  onRowClick(rowData: any) {
    this.rowClick.emit(rowData);
  }

  abrirModal(campanha: any, event: Event) {
    event.stopPropagation();
    const prorrogarAtiva = campanha.prorrogar?.find((p: { ativo: any; }) => p.ativo);

    if (prorrogarAtiva) {
      this.prorrogarSelecionada = prorrogarAtiva;
      this.displayModal = true;
    }
  }

  temProrrogarAtiva(campanha: any): boolean {
    return campanha.prorrogar?.some((p: { ativo: boolean; }) => p.ativo);
  }
    
  AprovarProrrogacao(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja aprovar esta prorrogação?. Esta ação é irreversível?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Prorrogar',
      },
      accept: () => {
    this.loading = true;
        const id = campanha?.id;

        this.campanhaService.aprovarProrrogacao(id).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Campanha prorrogada com sucesso!',
              life: 5000
            });
            this.displayModal = false;

          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao prorrogar a campanha',
              life: 5000,
            });
            console.error(err);
          }
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
        this.displayModal = false;
      },
    });
  }
}